import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUserManager } from '@components/Auth/manager';
import { setToken } from '@actions/authActions';
import { makeCurrentUser } from '@actions/userActions';
import { useDispatch } from 'react-redux';
import { MgLocalStorageKeys } from '@enums';

export const useAuth0Login = () => {
  const dispatch = useDispatch();
  const [hasSignInFailed, setHasSignInFailed] = useState(false);

  const navigate = useNavigate();

  const trySignInAsync = async () => {
    try {
      const userManager = getUserManager();
      const { state, access_token } = await userManager.signinRedirectCallback();
      dispatch(setToken(access_token));
      dispatch(makeCurrentUser());

      await userManager.clearStaleState();
      const path = localStorage.getItem(MgLocalStorageKeys.REDIRECT_PATH);
      navigate(path ? path : state);
      localStorage.removeItem(MgLocalStorageKeys.REDIRECT_PATH);
    } catch {
      setHasSignInFailed(true);
    }
  };

  useEffect(() => {
    trySignInAsync();
  }, []);

  return { hasSignInFailed };
};
